import { Reveal } from "./Reveal";
import { MANIFESTO, COURSE_PROCESS } from "../../data/content";

export const Manifesto = () => (
  <section id="approach" data-testid="approach-section" className="bg-ink text-paper">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
      <Reveal className="max-w-3xl">
        <p className="overline text-terracotta">(02) — The Method</p>
        <h2 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]">
          How a course
          <br />
          actually gets built.
        </h2>
      </Reveal>

      <div className="mt-16 md:mt-24 divide-y divide-white/10 border-t border-white/10">
        {MANIFESTO.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.06}>
            <div className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 items-start">
              <div className="md:col-span-2 font-serif text-6xl md:text-7xl font-light text-white/25 group-hover:text-terracotta transition-colors duration-500 leading-none">
                {c.no}
              </div>
              <h3 className="md:col-span-3 font-serif italic text-3xl md:text-4xl tracking-tight leading-none">
                {c.title}
              </h3>
              <p className="md:col-span-7 text-base md:text-lg text-white/60 leading-relaxed max-w-2xl">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 md:mt-28">
        <p className="overline text-terracotta">My process, in my own way</p>
        <h3 className="mt-5 font-serif text-3xl md:text-5xl tracking-tight leading-[1.05] max-w-3xl">
          Not every great designer follows the same path. This is mine.
        </h3>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-white/60 leading-relaxed">
          Frameworks like ADDIE and SAM are the foundation, but the real work lives in the
          judgment calls between the steps. Here's how I personally take a course from a vague
          request to something live, tested, and genuinely useful.
        </p>
        <ol className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-0" data-testid="course-process-list">
          {COURSE_PROCESS.map((step, i) => (
            <li
              key={i}
              data-testid={`course-process-step-${i + 1}`}
              className="group flex items-start gap-5 border-t border-white/10 py-5 transition-colors duration-300 hover:border-terracotta/60"
            >
              <span className="font-grotesk text-xs uppercase tracking-[0.2em] text-white/35 pt-1.5 tabular-nums group-hover:text-terracotta transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-base md:text-lg text-white/75 leading-snug">{step}</span>
            </li>
          ))}
        </ol>
      </Reveal>
    </div>
  </section>
);
